import {
  formatValidationSummaryZh,
  localizeValidationFieldsZh,
  translateValidationMessage,
} from '@uo/shared';
import { ApiError } from '../api/client';

/** User-facing error text (Chinese when possible). */
export function formatApiErrorMessage(err: unknown, fallback = '操作失败'): string {
  if (err instanceof ApiError) {
    if (err.fields && Object.keys(err.fields).length > 0) {
      const fields = localizeValidationFieldsZh(err.fields);
      return formatValidationSummaryZh(fields);
    }
    const msg = translateValidationMessage(err.message);
    if (msg === '提交信息有误，请检查表单') {
      return '提交信息有误，请检查下方标红项（用户名、邮箱、密码、交易密码、密保答案等）';
    }
    return msg && msg !== 'api error' ? msg : fallback;
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
